// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T6py","importantInfo":"styles_importantInfo__2F8oW"};